import { Item } from '@/api/items/items.types';
import { Box, Skeleton, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { ProductCard } from './product-card';
import { ActiveFilters } from './active-filters';
import { VirtuosoGrid } from 'react-virtuoso';
import { forwardRef } from 'react';

const ListComponent = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>((props, ref) => (
  <div
    ref={ref}
    {...props}
    style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: 12,
      ...props.style,
    }}
  />
));

const ItemComponent = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>((props, ref) => (
  <Box
    ref={ref}
    {...props}
    sx={{
      width: {
        xs: 'calc(50% - 6px)',
        sm: 'calc(33.333% - 8px)',
        md: 'calc(25% - 9px)',
        lg: 'calc(16.666% - 10px)',
      },
      height: 300,
    }}
  />
));

const components = { List: ListComponent, Item: ItemComponent };

export function CatalogBrowse({
  items,
  isLoading,
  scrollParent,
}: {
  items: Item[];
  isLoading: boolean;
  scrollParent: HTMLDivElement | null;
}) {
  return (
    <>
      <ActiveFilters />

      {isLoading ? (
        <Grid container spacing={1.5}>
          {[...Array(12)].map((_, i) => (
            <Grid key={i} size={{ xs: 6, sm: 4, md: 3, lg: 2 }}>
              <Skeleton variant="rounded" height={260} />
            </Grid>
          ))}
        </Grid>
      ) : items.length === 0 ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 200,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Keine Artikel gefunden
          </Typography>
        </Box>
      ) : scrollParent ? (
        <VirtuosoGrid
          customScrollParent={scrollParent}
          totalCount={items.length}
          components={components}
          itemContent={(index) => <ProductCard item={items[index]} />}
          overscan={900}
        />
      ) : null}
    </>
  );
}
